import { CreateService, CRUDServiceInterface } from '@/services/service';
import { BulletinCommentReactionEntity } from '@/entities/bulletin-comment-reaction.entity';

export default class BulletinCommentReactionService
  extends CreateService<BulletinCommentReactionEntity>(
    'bulletin-comment-reaction',
  )
  implements CRUDServiceInterface<BulletinCommentReactionEntity>
{
  async getMany(
    commentId: string | number,
    emoticonId: string | number,
  ): Promise<BulletinCommentReactionEntity[]> {
    await this.apiBuilder.reset();
    const [items] = await this.apiBuilder
      .clone()
      .join('staff')
      .filter('commentId', '$eq', String(commentId))
      .filter('emoticonId', '$eq', String(emoticonId))
      .getMany();
    return items;
  }
}
